import { useEffect, useState } from "react";

/** Show a loader only after `delayMs` so fast/cached loads never flash UI. */
export function useDelayedLoader(active: boolean, delayMs = 220): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!active) {
      setShow(false);
      return;
    }
    const timer = window.setTimeout(() => setShow(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [active, delayMs]);

  return show;
}
